<template>
  <div class="column1-container">
    <div class="title">遂宁市物流大数据</div>
    <div class="output-value">
      <!-- {{year}}年物流总产值<span>{{count}}</span>万元 -->
      <!-- 2021年物流总产值<span>{{count}}</span>万元 -->
      {{year}}年物流总产值
      <span>
        <dv-digital-flop :config="{
          number: [Number(count)],
          toFixed: 2,
          style: line1Style,
          animationCurve: 'easeOutCubic',
          animationFrame: 100
        }" 
        style="width: 310px; height: 75px" />
      </span>亿元
    </div>
    <bar-chart-1></bar-chart-1>
    <bar-chart-2></bar-chart-2>
  </div>
</template>

<script>
// import { localgrossvalueGet } from '../../api/colunm1'
import axios from 'axios'
import BarChart1 from "./BarChart1"
import BarChart2 from "./BarChart2"
export default {
  components: {
    BarChart1,
    BarChart2
  },

  data () {
    return {
      count: 0,
      timer: null,
      line1Style: {
        fill: '#34DEE5',
        fontSize: 68,
        fontWeight: 'bold'
      }
    }
  },

  computed: {
    year () {
      const date = new Date()
      return date.getFullYear()
    }
  },

  created () {
    this.getValue()
  },

  methods: {
    getValue () {
      axios.get('https://sry.chuangxing.ren/api/index/getThisYearLogisticsProduction?server=1')
        .then(response => {
          if (response.data && response.data.code === 1) {
            this.count = Number(response.data.data).toFixed(2)
          } else {
            console.error('获取数据失败:', response.data)
            this.count = 0
          }
          this.timer && clearInterval(this.timer)
          this.timer = setTimeout(this.getValue, 1000 * 10)
        })
        .catch(error => {
          console.error('API请求错误:', error)
          this.count = 0
          this.timer && clearInterval(this.timer)
          this.timer = setTimeout(this.getValue, 1000 * 10)
        })
    },
  }
}
</script>

<style lang="less" scoped>
.column1-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 648px;
  height: 100%;
  padding-top: 50px;
  .title {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-30%);
    width: 100%;
    color: #34dee5;
    font-size: 50px;
    font-weight: bold;
    text-align: center;
  }
  .output-value {
    display: flex;
    align-items: flex-end;
    color: white;
    font-size: 30px;
    text-align: center;
    span {
      transform: translateY(15px);
      display: inline-block;
      margin: 0 10px;
      background-image: linear-gradient(to right, rgba(10, 00, 127, 0),rgba(10, 00, 127, 0.9),
                      rgba(10, 00, 127, 0));
    }
  }
}
</style>